import React from 'react';
import PropTypes from 'prop-types';
import StripeDefs from 'components/stripe-defs';
import {getTranslate} from 'utils/attribute-util';
import {getHeight, getWidth} from 'utils/layout-util';
import {getColumnStyle} from 'utils/style-util';
import {isValid} from 'validators/number-validator';
import Colors from 'common/constants/colors';
import styles from './index.css';

export default class Column extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    divider: PropTypes.bool,
    height: PropTypes.number,
    style: PropTypes.object,
    tickWidth: PropTypes.number,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    active: false,
    className: '',
    divider: false,
    height: 0,
    style: {},
    tickWidth: 0,
    width: 0,
    x: 0,
    y: 0,
  };

  getRectX(width, tickWidth) {
    if (isValid(width) && isValid(tickWidth)) {
      return Math.abs(Math.round(tickWidth / 2 - width / 2));
    }
    return 0;
  }

  render() {
    const height = getHeight(this.props.height);
    const style = getColumnStyle(
      this.props.active,
      this.props.style.fill,
      this.props.style.fillActive,
      StripeDefs.getMaskID(),
    );
    const translate = getTranslate(this.props.x, this.props.y);
    const width = getWidth(this.props.width);
    const rectX = this.getRectX(this.props.width, this.props.tickWidth);
    return (
      <g className={styles.Column} transform={translate}>
        <rect height={height} style={style} width={width} x={rectX} />
        {this.props.divider ? (
          <rect
            height={1}
            style={{
              fill: Colors.white,
            }}
            width={width}
            x={rectX}
          />
        ) : null}
      </g>
    );
  }
}
